import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import theme from 'theme';
import _ from 'lodash';

/**
 * Hook cho component SelectingTable
 * Cung cấp các hàm và state cơ bản cho việc chọn, bỏ chọn các dòng trong bảng.
 * 
 * @param {Array} defaultSelected - Danh sách ID được chọn mặc định
 * @returns {Object} object chứa các state và function xử lý selection trong bảng
 */
const useSelectingTable = (defaultSelected = []) => {
    const isLargePC = useMediaQuery(theme.breakpoints.up('xl'));
    const [selected, setSelected] = useState(defaultSelected);

    /**
     * Xử lý khi nhấn chọn/bỏ chọn tất cả trên header
     * @param {Event} event 
     * @param {Array} data - danh sách dữ liệu đang hiển thị trên bảng
     * @param {String} rowIdKey - tên field được dùng làm ID (mặc định là 'id')
     */
    const handleSelectAllClick = (event, data = [], rowIdKey = 'id') => {
        const displayedIds = data.map((row) => row[rowIdKey]);

        if (event.target.checked) {
            // Thêm tất cả ID đang hiển thị vào selected
            setSelected(prev => _.uniq([...prev, ...displayedIds]));
        } else {
            // Xóa tất cả ID đang hiển thị khỏi selected
            setSelected(prev => prev.filter(id => !displayedIds.includes(id)));
        }
    };

    /**
     * Xử lý khi chọn/bỏ chọn một dòng
     * @param {Boolean} checked - trạng thái checkbox
     * @param {String|Number} id - ID của dòng
     */
    const handleClick = (checked, id) => {
        if (checked) {
            setSelected(prev => [...prev, id]);
        } else {
            setSelected(prev => prev.filter(item => item !== id));
        }
    };

    /**
     * Kiểm tra xem một dòng có đang được chọn hay không
     * @param {String|Number} id 
     * @returns {Boolean}
     */
    const isSelected = (id) => selected.includes(id);

    return {
        selected,
        setSelected,
        handleSelectAllClick,
        handleClick,
        isSelected,
        sizeRow: isLargePC ? 'medium' : 'small',
    };
};

export default useSelectingTable;